import React, { useEffect } from 'react';
import anime from 'animejs';
import { FaAnchor, FaShip, FaQuoteLeft } from 'react-icons/fa';
import yeniImage from '../assets/images/shipagency.webp';

export default function About() {
  useEffect(() => {
    const tl = anime.timeline({
      easing: 'easeOutExpo',
    });

    tl.add({
      targets: '.header-reveal',
      opacity: [0, 1],
      translateY: [40, 0],
      duration: 1000,
    })
    .add({
      targets: '.content-card',
      opacity: [0, 1],
      translateY: [25, 0],
      duration: 750
    }, '-=650'); 
  }, []);

  return (
    <div className="bg-[#fdfcfb] min-h-screen font-sans selection:bg-[#c4a47c] selection:text-white overflow-x-hidden">
      

      <section className="relative py-24 md:py-36 bg-[#0a111f] overflow-hidden">
        <div className="absolute inset-0 z-0 opacity-20">
          <img src={yeniImage} alt="Armar Shipping Agency Vessel" className="w-full h-full object-cover grayscale scale-105" />
        </div>
        
        <div className="absolute top-0 left-1/4 w-[300px] md:w-[500px] h-[300px] md:h-[500px] bg-blue-500/5 rounded-full blur-[120px] pointer-events-none"></div>
        <div className="absolute bottom-0 right-0 w-[250px] md:w-[400px] h-[250px] md:h-[400px] bg-[#c4a47c]/5 rounded-full blur-[100px] pointer-events-none"></div>
        
        <div className="max-w-7xl mx-auto px-6 md:px-8 relative z-10 text-center header-reveal">
          <div className="flex items-center justify-center space-x-3 mb-6">
            <div className="h-[1px] w-8 md:w-12 bg-[#c4a47c]"></div>
            <FaAnchor className="text-[#c4a47c] text-xs" />
            <div className="h-[1px] w-8 md:w-12 bg-[#c4a47c]"></div>
          </div>
          <h1 className="text-3xl md:text-4xl lg:text-5xl  font-black text-white uppercase italic tracking-tighter leading-none mb-4">
            About <span className="text-[#c4a47c]">Us</span>
          </h1>
          <p className="text-[#c4a47c]/60 text-[9px] md:text-[10px] font-black uppercase tracking-[0.3em] md:tracking-[0.5em]"> Since 2011</p>
        </div>
      </section>

      {/* İçerik Bölümü */}
      <div className="max-w-5xl mx-auto px-4 md:px-8 -mt-12 md:-mt-16 relative z-20 pb-20 md:pb-32">
        <article className="content-card">
          <div className="bg-white p-6 md:p-20 rounded-[2rem] md:rounded-[3rem] shadow-[0_40px_100px_rgba(0,0,0,0.05)] border border-[#f0e6d6]">
            
            <div className="flex items-center space-x-3 mb-10 md:mb-16 border-b border-[#f0e6d6] pb-8">
              <FaShip className="text-[#c4a47c]" />
              <h2 className="text-sm font-black uppercase tracking-widest text-slate-900 leading-tight"></h2>
            </div>
            
            <div className="space-y-10 md:space-y-16">
              
              <div className="relative group">
                <p className="text-xl md:text-2xl font-black text-[#0a111f] leading-tight uppercase italic tracking-tight border-l-4 border-[#c4a47c] pl-6 md:pl-8 transition-all duration-500">
                  ISTANBUL, embraces two continents with one "ARM" reaching out to ASIA and the other to EUROPE, through the city's heart, the BOSPHORUS, course the waters of the BLACK SEA, the SEA OF MARMARA and the GOLDEN HORN.
                </p>
              </div>

              <div className="text-slate-700 leading-relaxed md:leading-loose text-base md:text-lg font-medium">
                <p>
                  <span className="hidden md:inline text-5xl font-black text-[#0a111f] mr-2 float-left leading-[0.8]">A</span>
                  RMAR SHIPPING COMPANY (ARMARSHIP), has been established in Istanbul on 11.11.2011 with the aim of providing a comprehensive agency services for valuable Charterers & Ship Owners & Operators in a proper manner, reliable and professional way at TURKISH STRAITS and PORTS plus at Turkish main Shipyards in Tuzla and Yalova areas.
                </p>
              </div>

              <div className="relative py-8 md:py-12 px-6 md:px-10 bg-[#fdfcfb] rounded-[1.5rem] md:rounded-[2.5rem] border border-[#f3eee7] italic shadow-sm group">
                <FaQuoteLeft className="text-[#c4a47c]/10 text-4xl md:text-6xl absolute top-4 left-4" />
                <p className="relative z-10 text-slate-800 text-lg leading-relaxed font-bold md:pl-4">
                  The company owned by a professional named <span className="text-[#c4a47c] not-italic underline underline-offset-4 md:underline-offset-8 decoration-1">Mr. Laki Pribilovic</span> having 39 years of business skills in Shipping industry and a very good knowledge for utmost satisfaction of its principals with his huge powerful way of work, observing ships 7/24, solving any problem may arise to the vessels, protecting the rights of Charterers, Owners and crew members plus ensure ships smooth passages thru the straits and fast operations at all Turkish ports.
                </p>
              </div>

              <div className="text-slate-600 font-semibold leading-relaxed md:leading-loose text-[15px] md:text-[17px]">
                <p>
                  We are attending all type of vessels at Dardanelles and Bosphorus straits, with our dedicated personnel profile and having sub-offices at all Turkish ports all well known in the market. We have also very close co-operation to shipping community in Türkiye, plus monitoring very tight procedures of our vessels thru the state authorities VTS & harbour master, customs, immigrations, sanitary and pilotage managements, always having great relations.
                </p>
              </div>

              <div className="pt-8 md:pt-12 border-t border-[#f0e6d6]">
                <p className="font-black text-[#0a111f] uppercase tracking-tighter text-lg md:text-2xl leading-snug">
                  ARMAR's concept is based on <span className="text-[#c4a47c]">high efficiency</span>, reliability and always open to construct mutual relation for long business partnership, furthermore economical and the fastest turnaround smooth operation is the main goal so far we maintained.
                </p>
              </div>

            </div>
          </div>
        </article>
      </div>
      
      <div className="h-2 bg-gradient-to-r from-[#0a111f] via-[#c4a47c] to-[#0a111f]"></div>
    </div>
  );
}